<template>
    <span :title="result">{{result}}</span>
</template>

<script>
import {mapState} from 'vuex'
export default {
    props:['stamp'],
    data(){
        return {
            relative: (new Date).getTime()
        }
    },
    computed:{
        difference(){
            return this.relative - Number(this.stamp)
        },
        result(){
            if(this.difference > 604800000){
                return this.getDate(this.stamp)
            }
            if (this.difference > 60000) {
                let {text,time} = this.$relative(this.difference)
                return this.$t(text,{time})
            }else{
                return this.$t('Recently')
            }
        },
        ...mapState([
            'timer'
        ])
    },
    watch:{
        timer(cur){
            this.relative = (new Date).getTime()
        }
    },
    methods:{
        getDate(timestamp){
            let date = new Date(timestamp)
            let Y = date.getFullYear() + '-'
            let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() 
            return Y + M + D 
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/DatePassBy.vue